define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/action/Controller",
	"csi/comm",
	"csi/comm/PostRequest",
	"csi/form/Widget",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType",
	"./MassUpdateCostScenarioForm"
], function(array,declare,lang,Memory,csi,Controller,comm,PostRequest,FormWidget,ActionControllerMixin,xml,Query,ProductType) {

	var
	FIELD_REFRESH_OR_RESET = "Option",
    FIELD_COST_TYPE = "UpdateCostScenarioCostType",

    MATERIAL_COSTS = "0",
    OPERATION_COSTS = "1",
    BOTH_COSTS = "2",

	REFRESH = "0",
	RESET = "1",

	CURR_REV_PATH = "Child:CurrentRevision";

	return declare([Controller, ActionControllerMixin], {
		_quotes: null,

		getFormData: function() {
			// summary: make sure that at least one PartMaterial is selected
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateItem);
			return fd;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for suppliers view
			if (index == 1) {
				var query = new Query();

				query.Node(xml.PROP_TYPE, xml.OP_EQUALS, "SupplierItem")
					 .Attr("State", xml.OP_EQUALS, "Revision.State:DRAFT", CURR_REV_PATH)
					 .RefAttr("QuoteCostScenario", xml.OP_NOT_EQUALS, csi.EMPTY_URL, CURR_REV_PATH);

				if (this.m_formData.getFieldValue(FIELD_COST_TYPE) == MATERIAL_COSTS) {
					query.RefAttr("QuoteBOM", xml.OP_NOT_EQUALS, csi.EMPTY_URL, CURR_REV_PATH)
				} else if (this.m_formData.getFieldValue(FIELD_COST_TYPE) == OPERATION_COSTS) {
					query.RefAttr("QuoteRouting", xml.OP_NOT_EQUALS, csi.EMPTY_URL, CURR_REV_PATH);
				}

				return query;
			}

			return null;
		},


		process: function() {
			this.getFormData();
			var	fd = this.m_formData;
			var	costType = fd.getFieldValue(FIELD_COST_TYPE);
			var	refershOrReset = fd.getFieldValue(FIELD_REFRESH_OR_RESET);
			this._quotes = csi.hashArray(this.getFormData().getSelectedValue(), null, Boolean);

			var isRefresh = (refershOrReset == REFRESH);
			var isOperationCost = (costType == OPERATION_COSTS || costType == BOTH_COSTS);
			var isMaterialCost = (costType == MATERIAL_COSTS || costType == BOTH_COSTS);

			// iterate through all quotes
			for (var url in this._quotes) {
				this.m_writer.callMethod("Sourcing", "MassUpdateCostScenario")
				  .addParameter("ParentURL", xml.ATTR_REF, url)
				  .addParameter("IsRefresh", xml.ATTR_BOOLEAN, isRefresh)
				  .addParameter("IsOperationCost", xml.ATTR_BOOLEAN, isOperationCost)
				  .addParameter("IsMaterialCost", xml.ATTR_BOOLEAN, isMaterialCost);

			}
			this.publish();
		},

        getStringParameters: function() {
            // summary: use return value as parameter to success message
            var v = this.m_response ? this.m_response.getReturnValue() : null;

            if (this._quotes != null && this.m_response != null && this.m_response.data != null && this.m_response.data.Status == "Successful") {
            	v = Object.keys(this._quotes).length;
            }

            return (v === null) ? null : [v];
        },

		_canAggregateItem: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: only allow selection of nodes with Write access
			return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
		}
	});
});